/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Paper,
  Table,
  TableBody,
} from '@material-ui/core';

import i18n from '../../i18n';

import EcommTableHeader from './EcommTableHeader';
import EcommTableFooter from './EcommTableFooter';
import EcommDataProductTierRow from './EcommDataProductTierRow';
import EcommDataSpecialProjectRow from './EcommDataSpecialProjectRow';
import EcommDataDateAndNameRow from './EcommDataDateAndNameRow';
import EcommDataNumberRow from './EcommDataNumberRow';
import EcommDataDropdownRow from './EcommDataDropdownRow';

import {
  studioBeautyTypeOptions,
} from '../../constants/general';
import { ecommTableNumericRows, ecommTableDropdownRows } from '../../constants/ecommDataTableRowLabelAndValueKey';
import {
  dropdownRowMap,
  numberRowMap
} from '../../helpers/ecommTableHelpers';
import '../../assets/stylesheets/Ecomm.css';
import { LocationType } from '../../validation';
import EcommDoubleBookingRows from './EcommDoubleBookingRows';

class EcommDataTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studioData: {
        ...props.studioData
      }
    };
  }

  handleChange = (event, key) => {
    event.persist();
    const { name, value } = event.target;
    this.saveChange(name, value, key);
  }

  saveChange = (name, value, key) => {
    const keyValues = { [name]: value };
    const { saveOne } = this.props;
    this.setState(prevState => ({
      studioData: {
        ...prevState.studioData,
        [key]: {
          ...prevState.studioData[key],
          [name]: value
        }
      }
    }));
    if (value || value === 0) {
      const { studioData } = this.state;
      saveOne({
        date: studioData[key].date,
        locationType: 'studio',
        locationId: studioData[key].locationId,
        keyValues,
        updatedAt: new Date().getTime() / 1000
      });
    }
  };

  handleSpecialProjectChange = (event, key) => {
    event.persist();
    const { name, value } = event.target;
    const { saveOne } = this.props;
    // value === -1 is 'None'
    const isSpecialProject = value !== -1;
    const projectName = isSpecialProject ? value : null;
    const keyValues = { [name]: projectName, isSpecialProject };
    this.setState(prevState => ({
      studioData: {
        ...prevState.studioData,
        [key]: {
          ...prevState.studioData[key],
          [name]: projectName,
          isSpecialProject,
        }
      }
    }),
    () => {
      const { studioData } = this.state;
      saveOne({
        date: studioData[key].date,
        locationType: 'studio',
        locationId: studioData[key].locationId,
        keyValues,
        updatedAt: new Date().getTime() / 1000
      });
    });
  };

  handleDoubleHmuCheckbox = (event, key) => {
    const { checked } = event.currentTarget;
    const keyValues = { isDoubleHmu: checked };
    const { saveOne } = this.props;
    this.setState(
      prevState => ({
        studioData: {
          ...prevState.studioData,
          [key]: {
            ...prevState.studioData[key],
            isDoubleHmu: checked
          }
        }
      }),
      () => {
        const { studioData } = this.state;
        saveOne({
          date: studioData[key].date,
          locationType: 'studio',
          locationId: studioData[key].locationId,
          keyValues,
          updatedAt: new Date().getTime() / 1000
        })
      });
  };

  getTabIndex = (column)=>{
    const { startTabIndex } = this.props;
    return startTabIndex + column
  }

  render() {
    const { studioData } = this.state;
    const {
      handleDatePickerChange,
      date,
      fetchPrevious,
      fetchNext,
      getNow,
      specialProjectOptions,
      canEdit,
      locationType
    } = this.props;

    return (
      <Paper className="ecommForm">
        <Table>
          <EcommTableHeader
            headerKey="StudioTitle"
            tableTitle={i18n.t('location:studioTableTitle')}
          />
          <TableBody>
            <EcommDataDateAndNameRow
              date={date}
              fetchNext={fetchNext}
              fetchPrevious={fetchPrevious}
              handleDatePickerChange={handleDatePickerChange}
              locationNames={Object.keys(studioData).map(element =>
                studioData[element].studioName)}
            />
            {ecommTableDropdownRows.slice(2, 3).map(dropdownRowMap(canEdit, this.handleChange, this.getTabIndex, studioData))}
            {ecommTableNumericRows.slice(3, 7).map(numberRowMap(canEdit, this.handleChange, this.getTabIndex, studioData))}
            {ecommTableNumericRows.slice(7, 11).map(numberRowMap(canEdit, this.handleChange, this.getTabIndex, studioData))}
            <EcommDataNumberRow
              getTabIndex={this.getTabIndex}
              key={i18n.t('location:percentage').toUpperCase()}
              canEdit={canEdit}
              handleChange={this.handleChange}
              locationData={studioData}
              max={999.99}
              rowTitle={i18n.t('location:percentage').toUpperCase()}
              valueKey="percentage"
            />
            {ecommTableDropdownRows.slice(0, 1).map(dropdownRowMap(canEdit, this.handleChange, this.getTabIndex, studioData))}
            <EcommDoubleBookingRows 
              locationType={locationType}
              saveChange={this.saveChange}
              canEdit={canEdit}
              studioData={studioData}
              getTabIndex={this.getTabIndex}
            />
            <EcommDataDropdownRow
              canEdit={canEdit}
              getTabIndex={this.getTabIndex}
              key={i18n.t('location:typeOfBeauty').toUpperCase()}
              handleChange={this.handleChange}
              locationData={studioData}
              options={studioBeautyTypeOptions}
              rowTitle={i18n.t('location:typeOfBeauty').toUpperCase()}
              valueKey='typeOfBeauty'
            />
            <EcommDataSpecialProjectRow
              canEdit={canEdit}
              getTabIndex={this.getTabIndex}
              locationData={studioData}
              specialProjectOptions={specialProjectOptions}
              handleSpecialProjectChange={this.handleSpecialProjectChange}
            />
            {ecommTableNumericRows.slice(14, 16).map(numberRowMap(canEdit, this.handleChange, this.getTabIndex, studioData))}
            {ecommTableNumericRows.slice(16, 21).map(numberRowMap(canEdit, this.handleChange, this.getTabIndex, studioData))}
            <EcommDataProductTierRow
              canEdit={canEdit}
              getTabIndex={this.getTabIndex}
              locationData={studioData}
              handleChange={this.handleChange}
            />
          </TableBody>
          <EcommTableFooter getNow={getNow} />
        </Table>
      </Paper>
    );
  }
}

EcommDataTable.propTypes = {
  studioData: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  ).isRequired,
  locationType: LocationType.isRequired,
  specialProjectOptions: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  saveOne: PropTypes.func.isRequired,
  getNow: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  handleDatePickerChange: PropTypes.func.isRequired,
  fetchPrevious: PropTypes.func.isRequired,
  fetchNext: PropTypes.func.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  startTabIndex: PropTypes.number
};

EcommDataTable.defaultProps = {
  startTabIndex: 100
}

export default EcommDataTable;
